import api from './api'

// Public policy signing endpoints. These are unauthenticated on the backend;
// access to the document body is gated by a stateless grant string returned
// from verify-code and replayed via the X-Policy-Grant header.

export async function fetchPolicyMeta(token) {
  const { data } = await api.get(`/policy-links/${token}`)
  return data?.data ?? null
}

export async function requestPolicyAccessCode(token, email) {
  const { data } = await api.post(`/policy-links/${token}/request-code`, { email })
  return data
}

export async function verifyPolicyAccessCode(token, email, code) {
  const { data } = await api.post(`/policy-links/${token}/verify-code`, { email, code })
  return data?.data ?? null // { access_grant, email }
}

export async function fetchPolicyDocument(token, email, grant) {
  const { data } = await api.get(`/policy-links/${token}/document`, {
    params: { email },
    headers: { 'X-Policy-Grant': grant },
  })
  return data?.data ?? null
}

export async function signPolicyDocument(token, payload, grant) {
  const { data } = await api.post(`/policy-links/${token}/sign`, payload, {
    headers: { 'X-Policy-Grant': grant },
  })
  return data
}
